import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Cancel: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      d="M16.09 13.5001L11 18.5851C9.99999 19.5001 11.5 21.0002 12.415 20.0001L16.09 16.3251L19.765 20.0001C20.75 21 22 19.25 21.18 18.5851L16.09 13.5001Z"
      fill="currentColor"
    />
  </Icon>
);
